<template>
    <div class="header-bg" v-if="$store.state.show">
        <div class="header-box">
            <div class="header-left">
                <div class="logo">
                    <el-link
                    href="/"
                    target="_blank"
                    :underline="false">
                        <img src="/Public/home/images/wjsLOGO.png">
                    </el-link>
                </div>
            </div>

            <div class="header-right">
                <el-link
                type="info"
                :underline="false"
                href="/Index/dsb_product.html"
                target="_blank">
                数据</el-link>

                <el-link
                type="info"
                :underline="false"
                href="/Index/complain.html"
                target="_blank">
                投诉</el-link>

                <el-link
                type="info"
                :underline="false"
                href="/Index/finance.html"
                target="_blank">
                融资</el-link>

                <el-link
                type="info"
                :underline="false"
                href="/dh.html"
                target="_blank">
                导航</el-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
}
</script>

<style scoped>
.header-bg {
    width: 100%;
    background: #fff;
    border-bottom: #eee solid 1px;
    box-shadow: 0px 0px 9.5px 0.5px rgba(49, 87, 163, 0.13);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
}
.header-box {
    max-width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;
}
.header-left .logo img {
    height: 38px;
}
.header-left {
    height: 60px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}
.header-right {
    display: flex;
}
.header-right .el-link {
    line-height: 60px;
    padding: 0 12px;
}

@media(max-width: 868px) {
    .header-bg {
        position: inherit;
        padding: 10px 0;
    }
    .header-box {
        display: inherit;
    }
	.header-left {
	    height: auto;
		text-align: center;
	}
    .header-left .logo img {
        margin: 0 auto 10px;
    }
    .header-bg .el-autocomplete {
        width: 100%;
    }
    .header-right {
        justify-content: space-around;
    }
	.header-right .el-link {
		line-height: 20px;
		padding: 0;
	}
}
</style>